import { Component, OnInit } from '@angular/core';


interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ops-bk-remit',
  templateUrl: './ops-bk-remit.component.html',
  styleUrls: ['./ops-bk-remit.component.css']
})
export class OpsBkRemitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    { value: 'first-1', viewValue: 'First American Residential Val' },
    { value: 'second-2', viewValue: 'Nationwide Property & Appraisal' }
  ];

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }


}
